import { CHANNELS } from './channelConfig';
import {
  CLOUDINARY_ADMIN_WIDTH,
  cloudinaryDeliveryUrl,
} from '../../utils/cloudinaryDelivery';

/**
 * Aperçu campagne — image dominante en premier, CTA seulement si libellé + lien.
 */
export default function CampaignPreview({ form, commerceName }) {
  const channels = form.channels || [];
  const hasEmail = channels.includes('EMAIL');
  const hasInApp = channels.includes('IN_APP');
  const showCta = Boolean(String(form.ctaLabel || '').trim() && String(form.ctaUrl || '').trim());
  const title = form.title || form.subject || 'Titre';
  const message = form.message || 'Votre message…';
  const previewImageUrl = form.imageUrl
    ? cloudinaryDeliveryUrl(form.imageUrl, { width: CLOUDINARY_ADMIN_WIDTH.card }) || form.imageUrl
    : null;

  const CampaignCard = ({ channelLabel, showSafeZoneOverlay = false }) => (
    <div className="rounded-lg border border-gray-200 bg-white overflow-hidden shadow-sm">
      {previewImageUrl ? (
        <div className="relative">
          <img src={previewImageUrl} alt="" className="w-full h-36 object-cover" />
          {showSafeZoneOverlay ? (
            <div
              className="pointer-events-none absolute inset-0 flex items-center justify-center"
              aria-hidden
              data-testid="campaign-in-app-preview-safe-zone"
            >
              <div className="h-[55%] w-[70%] rounded-sm border border-dashed border-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.12)]" />
            </div>
          ) : null}
        </div>
      ) : (
        <div className="w-full h-24 bg-gradient-to-br from-gray-100 to-gray-50 flex items-center justify-center">
          <span className="text-xs text-gray-400">Sans image</span>
        </div>
      )}
      <div className="p-4">
        <p className="text-xs text-gray-500 mb-1">{channelLabel}</p>
        <p className="font-semibold text-gray-900">{title}</p>
        <p className="mt-2 text-sm text-gray-700 whitespace-pre-wrap line-clamp-6">{message}</p>
        {showCta && (
          <div className="mt-4">
            <span className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-primary-600 text-white text-sm font-medium">
              {form.ctaLabel.trim()}
            </span>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="space-y-4">
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Aperçu</p>

      {channels.length === 0 && (
        <p className="text-sm text-gray-500">Sélectionnez au moins un canal.</p>
      )}

      {hasInApp && (
        <CampaignCard
          channelLabel="Notifications dans l’application"
          showSafeZoneOverlay={Boolean(form.imageUrl)}
        />
      )}

      {hasEmail && (
        <div className="rounded-lg border border-gray-200 bg-gray-50 overflow-hidden">
          <div className="bg-white border-b border-gray-200 px-4 py-3">
            <p className="text-xs text-gray-500">De</p>
            <p className="text-sm text-gray-800">
              {commerceName && commerceName !== 'Clickorico'
                ? `${commerceName} via Clickorico`
                : 'Clickorico'}
            </p>
            <p className="text-xs text-gray-500 mt-2">Objet</p>
            <p className="text-sm font-medium text-gray-900">
              {form.subject || form.title || '(sans objet)'}
            </p>
          </div>
          {previewImageUrl && (
            <img src={previewImageUrl} alt="" className="w-full h-36 object-cover" />
          )}
          <div className="px-4 py-4">
            <p className="text-sm text-gray-800 whitespace-pre-wrap leading-relaxed line-clamp-8">
              {message}
            </p>
            {showCta && (
              <div className="mt-4">
                <span className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-primary-600 text-white text-sm font-medium">
                  {form.ctaLabel.trim()}
                </span>
              </div>
            )}
            <p className="mt-6 text-xs text-gray-400">
              Lien de désinscription ajouté automatiquement à l’envoi.
            </p>
          </div>
        </div>
      )}

      <div className="flex flex-wrap gap-1">
        {CHANNELS.filter((c) => channels.includes(c.id)).map((c) => (
          <span key={c.id} className="px-2 py-0.5 rounded bg-primary-50 text-primary-700 text-xs">
            {c.label}
          </span>
        ))}
      </div>
    </div>
  );
}
